import {JsonObject, JsonProperty} from "json2typescript";

import {JsonPropertyEmpty} from "../../utils/json-util";
import {TemplateItem} from "./template-item";

@JsonObject("TemplateItemUpsert")
export class TemplateItemUpsert {
    @JsonProperty("itemLabel", String)
    public itemLabel: string = JsonPropertyEmpty;
    @JsonProperty("itemList", [TemplateItem])
    public itemList: TemplateItem[] = JsonPropertyEmpty;

    constructor(init?: Partial<TemplateItemUpsert>) {
        Object.assign(this, init);
    }
}
